module.exports = __webpack_public_path__ + "static/media/hotel_de_ville.765d5061.jpg";